import Mapping from "./mapping";
// template type
export const SUCCESS_SCREEN = 2;
export const CASHLESS_SCREEN = 3;
export const CASHLESS_SUCCESS_SCREEN = 5;
export const NO_TEMPLATE_SELECTED = null;

// template type background color
export const success_template_type_color = "#9CE199";
export const pairing_template_type_color = "#e4e4e4";

export const TemplateStatus = {
	DRAFT: "DRAFT",
	PUBLISHED: "PUBLISHED",
	ARCHIVED: "ARCHIVED"
};

export class Template {
	constructor({ id, name, type, state, mapping, checkpoints } = {}) {
		this.id = id;
		this.name = name || "";
		this.type = type || null;
		this.state = state || "";
		this.checkpoints = checkpoints || [];
		this.checkpoint_ids = checkpoints?.map(item => item.id) || [];
		this.mapping = mapping ? new Mapping(mapping) : null;
	}

	getId() {
		return this.id;
	}
	getName() {
		return this.name;
	}
	getType() {
		return this.type;
	}
	getState() {
		return this.state;
	}
	getMapping() {
		return this.mapping;
	}

	set checkpoints(value) {
		this._checkpoints = value;
		this.checkpoint_ids =
			value?.map(item => item?.value ?? item?.id ?? item) ?? [];
	}

	get checkpoints() {
		return this._checkpoints;
	}

	toJSON() {
		return {
			name: this.name,
			type: this.type,
			state: this.state,
			checkpoint_ids: this.checkpoint_ids,
			mapping: this.mapping
		};
	}
}
